module.exports = __webpack_public_path__ + "static/media/2.b00db69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格未选中态/2.png
// module id = 1620
// module chunks = 0